import { render, staticRenderFns } from "./Trailers.vue?vue&type=template&id=8f2c186c&scoped=true&"
import script from "./Trailers.vue?vue&type=script&lang=js&"
export * from "./Trailers.vue?vue&type=script&lang=js&"
import style0 from "./Trailers.vue?vue&type=style&index=0&id=8f2c186c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2c186c",
  null
  
)

export default component.exports